module.exports = __webpack_public_path__ + "img/goldregen-2020-099.772fc94d.jpg";